import { createRoutine } from 'redux-saga-routines';

export const fetchLowStockItems = createRoutine(
  'FETCH_INVENTORY_LOW_STOCK_ITEMS'
);
